import React, { useEffect, useState } from "react";
import "./ExploreTopCities.css";
import HomeService from "../../Services/HomeService";
import { useNavigate } from "react-router-dom";

const cities = [
  { name: "Gurgaon", locations: 150 },
  { name: "South Delhi", locations: 120 },
  { name: "Central Noida", locations: 80 },
  { name: "Faridabad", locations: 60 },
  { name: "West Delhi", locations: 45 },
  { name: "North Delhi", locations: 30 },
];

const ExploreTopCities = () => {
  const [citiesWithCityDetails, setCitiesWithCityDetails] = useState([]);
  const navigate = useNavigate();

  const fetchCitiesWithCityDetails = async () => {
    try {
      const res = await HomeService.getCitiesWithCityDetails();
      console.log("city details header", res);
      if (res?.status) {
        setCitiesWithCityDetails(res?.data);
      } else {
        console.log(res);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCitiesWithCityDetails();
  }, []);

  return (
    <section className="cities-section-ex">
      <div className="cities-header-ex">
        <div>
          <span className="coverage-tag-ex">● Active Coverage</span>
          <h2 className="cities-title-ex">Explore Top Cities</h2>
        </div>

        <div className="cities-stats-ex">
          <div>
            <h3>10+</h3>
            <p>Total Cities</p>
          </div>

          <div>
            <h3>500+</h3>
            <p>Total Localities</p>
          </div>
        </div>
      </div>

      <div className="cities-wrapper-ex">
        {citiesWithCityDetails?.map((city, index) => (
          <div
            className="city-card-ex"
            key={index}
            onClick={() => {
              const city1 = city?.cityData?.name?.trim().replace(/\s+/g, "-");
              navigate(`/${city1}`, {
                state: { id: city?.cityData?._id },
              });
              // setIsCitySubMenuOpen(false);
            }}
          >
            <img
              style={{ height: "100%", width: "100%" }}
              src={city?.cityData?.image}
              alt="cityImage"
            ></img>
            <div className="city-overlay-ex" />
            {/* <i className="fa-solid fa-location-dot city-icon-ex"></i> */}
            <div className="city-content-ex">
              <h3>{city?.cityData?.name}</h3>
              <p>{city.locations} Localities</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ExploreTopCities;
